module.exports = __webpack_public_path__ + "static/media/ilustracao.bd278035.svg";